import { FC } from 'react';
import styles from './DocumentFileBadge.module.scss';

export interface DocumentFileBadgeProps {
  type: 'DWG' | 'PDF' | 'discipline' | string;
  label?: string;
  variant?: 'dwg' | 'pdf' | 'discipline';
}

export const DocumentFileBadge: FC<DocumentFileBadgeProps> = ({
  type,
  label,
  variant,
}) => {
  const normalizedType = type.toUpperCase();
  const v =
    variant ||
    (normalizedType === 'DWG'
      ? 'dwg'
      : normalizedType === 'PDF'
      ? 'pdf'
      : 'discipline');

  return (
    <span
      className={`${styles.badge} ${styles[v]}`}
      aria-label={`File type: ${label || type}`}
    >
      {label || type}
    </span>
  );
};
